import { $inject, $type } from '../utils/di-container.js';
import { JournalService } from './journal.service.js';
import { GlobalService } from './global.service.js';

/**
 * Simple logging service, to be extended if needed later (e.g. send errors to API).
 * Outputs all logs to console.debug in order to not intrude with badge warning/errors on company sites.
 */
export class LoggerService {

  /** @type {JournalService} */
  _journalSvc;

  /** @type {GlobalService} */
  _globalSvc;

  [$inject](obtain) {
    this._journalSvc = obtain(JournalService);
    this._globalSvc = obtain(GlobalService);
  }

  /**
   * Logger tag
   * @param {string} tag
   */
  constructor(tag) {
    this._tag = tag;
  }

  /**
   * @param {'DEBUG'|'INFO'|'WARN'|'ERROR'} level
   * @param {string} code
   * @param {string} message
   * @param {function} [dataFn]
   * @param {Error} [error]
   */
  log(level, code, message, dataFn, error) {
    if (this._globalSvc.keepJournal) {
      this._journalSvc.write('log', { level, code, message, data: dataFn ? dataFn() : {}, error });
    }
    if (this._globalSvc.consoleLogs) {
      let logMsg = `[${this._tag} ${level}] ${message}`;
      if (level === 'ERROR') {
        // stack trace might be useful here
        logMsg = logMsg + '\nStack: ' + (error || Error()).stack;
      }
      console.debug(logMsg);
    }
  }

  /**
   * @param {string} code
   * @param {string} message
   * @param {function} [dataFn]
   */
  debug(code, message, dataFn) {
    this.log('DEBUG', code, message, dataFn)
  }

  /**
   * @param {string} code
   * @param {string} message
   * @param {function} [dataFn]
   */
  info(code, message, dataFn) {
    this.log('INFO', code, message, dataFn)
  }

  /**
   * @param {string} code
   * @param {string} message
   * @param {function} [dataFn]
   */
  warn(code, message, dataFn) {
    this.log('WARN', code, message, dataFn)
  }

  /**
   * @param {string} code
   * @param {string} message
   * @param {function} [dataFn]
   * @param {Error} [error]
   */
  error(code, message, dataFn, error) {
    this.log('ERROR', code, message, dataFn, error)
  }

}

LoggerService[$type] = Symbol('LoggerService');
